export default __webpack_public_path__ + "static/media/Humber2-1.4b8ac950.gif";